<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b>Detection</b>
          <br>
          {{platform.name}}
          <br>
          {{platform.version}}
          <br>
          {{platform.product}}
          <br>
          {{platform.manufacturer}}
          <br>
          {{platform.layout}}
          <br>
          {{platform.os}}
          <br>
          {{platform.description}}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
var platformObj = require('platform');

export default {
  name: 'detection',
  computed: {
    platform () {
      return platformObj;
    }
  }
}
</script>
